import React from "react";
import { motion } from "framer-motion";

// Split a phrase into words, wrap in mask-line spans, animate y from 110% to 0
export function LineReveal({ text, delay = 0, className = "", el: El = "span" }) {
  const words = text.split(" ");
  return (
    <El className={className}>
      {words.map((w, i) => (
        <span key={i} className="mask-line mr-[0.22em] last:mr-0">
          <motion.span
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 0.9,
              delay: delay + i * 0.06,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            {w}
          </motion.span>
        </span>
      ))}
    </El>
  );
}

export function InView({ children, y = 30, delay = 0, className = "", once = true }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function ClipReveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      initial={{ clipPath: "inset(0 0 100% 0)" }}
      whileInView={{ clipPath: "inset(0 0 0% 0)" }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 1.1, delay, ease: [0.76, 0, 0.24, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
